/**
 * Memoise a dynamic-import (or any async) factory: load once, share the
 * promise, and on failure clear the memo so a transient chunk-load error
 * doesn't permanently disable the feature for the session. Shared by the
 * thumbnail pipeline and the lazy engine loaders (pdf.js, slide renderer).
 */
export function lazyOnce<T>(load: () => Promise<T>): () => Promise<T> {
  let promise: Promise<T> | null = null;
  return () => {
    if (!promise) {
      promise = load().catch(err => { promise = null; throw err; });
    }
    return promise;
  };
}
